/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From
import Service, { service } from '@ember/service';
// Ember Imports
import { isEmpty } from '@ember/utils';
// External Imports
import moment from 'moment';
// Internal Imports
import { getDeviceInfo } from '@linc-technologies/linced-common/utils/platform';

export default class PushNotificationsService extends Service {
  // Services
  @service
  store;

  // attachDevice binds the device to the user on log in.
  attachDevice(personId) {
    if (isEmpty(personId)) {
      return;
    }

    const deviceInfo = getDeviceInfo();
    if (!isEmpty(deviceInfo) && Object.keys(deviceInfo).length > 0) {
      // Make sure deviceInfo exists...
      this._getDevice(personId, deviceInfo.physicalId).then((currentDevice) =>
        this._createOrUpdateDevice(personId, currentDevice, deviceInfo),
      );
    }
  }

  // detachDevice unbinds the device from the user on log off.
  detachDevice(personId, callback) {
    if (isEmpty(personId)) {
      return callback();
    }

    const deviceInfo = getDeviceInfo();
    if (!isEmpty(deviceInfo) && Object.keys(deviceInfo).length > 0) {
      return this._getDevice(personId, deviceInfo.physicalId)
        .then((device) => this._destroyDevice(device))
        .finally(() => callback());
    }

    return callback();
  }

  // _createOrUpdateDevice creates a new device if currentDevice is null, otherwise it updates it.
  _createOrUpdateDevice(personId, currentDevice, deviceInfo) {
    let info = {
      platform: deviceInfo.platform,
      displayName: deviceInfo.model,
      make: deviceInfo.make,
      model: deviceInfo.model,
      osVersion: deviceInfo.osVersion,
      physicalId: deviceInfo.physicalId,
      token: deviceInfo.notificationToken,
      fcmToken: deviceInfo.fcmToken,
    };

    if (isEmpty(currentDevice)) {
      let createTime = moment().utc().unix();
      let device = {
        createTime: createTime,
        updateTime: createTime,
        personId: personId,
      };
      currentDevice = this.store.createRecord('device', device);
    }
    currentDevice.setProperties(info);

    if (currentDevice.hasDirtyAttributes) {
      return currentDevice.save().catch(() => {
        currentDevice.rollbackAttributes();
      });
    }
  }

  // _getDevice finds a device record based on the Device's Physical ID.
  _getDevice(personId, physicalId) {
    return this.store
      .query('device', { personId, physicalId })
      .then((records) => this._filterDevices(records));
  }

  // _filterDevices returns a single device, or null.
  _filterDevices(records) {
    if (isEmpty(records)) {
      return Promise.resolve();
    }

    // Return the first device in the returned device array.
    return Promise.resolve(records.at(0));
  }

  // _destroyDevice deletes the provided device.
  _destroyDevice(device) {
    if (isEmpty(device)) {
      return Promise.resolve();
    }

    return device.destroyRecord().catch(() => {
      device.rollbackAttributes();
    });
  }
}
